import { Input } from 'components/core-v2/atoms'
import { HTMLProps } from 'react'
import { RegisterOptions, useFormContext } from 'react-hook-form'
import { ClassName } from 'types/props'

import { getFieldIds } from './__utils__/getFieldIds'

export interface FieldProps extends ClassName {
  id: string
  isDisabled?: boolean
  placeholder?: string
  type: HTMLProps<HTMLInputElement>['type']
  validators?: RegisterOptions
}

export const FieldOnly = ({
  className,
  id,
  isDisabled = false,
  placeholder,
  type,
  validators
}: FieldProps) => {
  const { register } = useFormContext()

  const { describedBy, inputId } = getFieldIds(id)

  return (
    <Input
      aria-describedby={describedBy}
      className={className}
      id={inputId}
      isDisabled={isDisabled}
      placeholder={placeholder}
      type={type}
      {...register(id, validators)}
    />
  )
}
